module.exports = __webpack_public_path__ + "img/lock_text_p.f053f9d0.svg";